import React from 'react';
import classNames from 'classnames';

import styles from '../nav/nav.module.scss';

export const MenuDivider = ({ className }) => (
  <div className={classNames('menu-divider', styles.menuDivider, className)} />
);
